import styled from '@emotion/styled'

import colorNames from '../../design/color-names'
import tokens, { input } from '../../design/tokens'

import { INPUT_COLOR_VARIANT_DANGER } from './constants'

const handleContainerVariant = ({ $variant }) => {
  return $variant === INPUT_COLOR_VARIANT_DANGER
    ? `border-color: ${input.color.border.danger};`
    : `border-color: ${input.color.border.default};
      &:hover {
        border-color: ${input.color.border.hover}
      }`
}

export const ColorPickerContainer = styled.div`
  label: input-color-container;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: ${input.borderRadius};
  box-sizing: border-box;
  height: 36px;
  transition: all 0.3s ease;

  ${handleContainerVariant}
  ${({ $disabled }) =>
    $disabled
      ? `background-color: ${input.color.background.disabled};`
      : `background-color: ${input.color.background.default};`}

  input[type="text"] {
    border: none !important;
    height: 34px;
    line-height: 34px;
  }
`

export const ColorPickerInput = styled.input`
  label: input-color-input;
  flex-grow: 1;
  appearance: none;

  outline: none;
`

export const ColorPickerPreviewContainer = styled.div`
  padding-left: 8px;
  padding-right: 8px;
`

export const ColorPickerPreview = styled.div`
  label: input-color-preview;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 24px;
  width: 24px;
  height: 24px;

  box-shadow: 0 0 0 1px rgba(37, 37, 37, 0.3) inset; /* mineshaft */

  ${({ $disabled }) =>
    $disabled ? 'pointer-events:none;' : 'cursor: pointer;'}
`

const handlePopupShow = ({ $show }) =>
  $show ? 'opacity: 1;  ' : 'opacity: 0; visibility: hidden; '

export const ColorPickerPopupContainer = styled.div`
  label: input-color-popup-container;
  z-index: 1000;

  box-shadow: ${tokens.shadows.default};
  position: absolute;
  right: -1px;
  top: 40px;
  transition: all 0.25s ease;

  border: 1px solid ${colorNames.geyser};
  border-radius: ${tokens.borderRadius.medium};

  padding: 8px;

  background-color: ${colorNames.pureWhite};

  ${handlePopupShow}

  .react-colorful {
    width: auto;
    height: auto;
  }

  .react-colorful__saturation {
    border-bottom: none;
    border-radius: 0;
    margin-bottom: 4px;
    width: 140px;
    height: 140px;
  }

  .react-colorful__hue {
    height: 16px;
  }

  .react-colorful__last-control {
    border-radius: 0;
  }

  .react-colorful__pointer {
    height: 14px;
    width: 14px;
  }

  .react-colorful__interactive:focus .react-colorful__pointer {
    transform: translate(-50%, -50%) scale(1);
  }
`

export const ColorPickerPopupControls = styled.div`
  label: input-color-popup-controls;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;

  a {
    font-size: ${tokens.fontSize.xsmall};
  }
`

export const transparentBackground = {
  background: `repeating-conic-gradient(${colorNames.alto} 0% 25%, transparent 0% 50%) 50% / 12px 12px`
}
